// Theme system was retired Feb 2026 — the app now ships a single Navy palette
// driven purely by CSS variables. These shims remain so legacy imports don't
// crash, but they are no-ops: nothing toggles, nothing is stored.

const NAVY = "navy";

export function getStoredTheme() { return NAVY; }
export function getSystemTheme() { return NAVY; }
export function getActiveTheme() { return NAVY; }
export function applyTheme() { return NAVY; }
export function toggleTheme() { return NAVY; }

/** Call once at app startup. Clears any stale dark-mode attribute. */
export function initTheme() {
  try {
    document.documentElement.removeAttribute("data-theme");
    localStorage.removeItem("claimops:theme");
  } catch (err) {
    // Non-fatal — SSR, private-mode storage block, or stale DOM access.
    // Log so it surfaces in dev, but don't crash app startup.
    console.warn("initTheme: could not reset theme state", err);
  }
  return NAVY;
}
